// import React, { useCallback, useEffect, useState } from "react";
// import LoadingAnimation from "../../assets/svg/LoadingAnimation";
// import { colors } from "@nextui-org/theme";
// import { useNavigate } from "react-router-dom";
// import { useSnackbar } from "notistack";
// import { useSelector } from "react-redux";
// import {
//   candidateAppliedJobs,
//   candidateMatchedJobs,
// } from "../../endpoints/job.service";
// import dayjs from "@lib/dayjs";
// import JobMatchedDetailPage from "./JobMatchedDetailPage";

// const JobMatchesPage = () => {
//   const navigate = useNavigate();
//   const [isLoading, setIsLoading] = useState(false);
//   const [jobList, setJobList] = useState();

//   const handleItemClick = (item) => {
//     navigate("/job-matches-details", { state: { item } });
//   };

//   const fetchMatchedJobs = useCallback(async () => {
//     try {
//       setIsLoading(true);
//       const { data, success } = await candidateMatchedJobs();
//       if (success) {
//         setJobList(data);
//       }
//     } catch (error) {
//       console.error(error);
//     } finally {
//       setIsLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     fetchMatchedJobs();
//   }, []);

//   return (
//     <div className="flex flex-col rounded-lg bg-white w-full flex-grow p-6">
//       {isLoading ? (
//         <div className="flex items-center justify-center h-full">
//           <LoadingAnimation color={colors.black} className={"w-4 h-4"} />
//         </div>
//       ) : jobList === undefined ? (
//         <p className="text-sm text-center mt-20">No matching jobs found yet.</p>
//       ) : (
//         <>
//           <div className="flex flex-col gap-4 justify-around rounded-lg bg-[#F1F5F9] py-4 px-6 mb-5">
//             <div className="flex  items-center w-full gap-6">
//               <div className="bg-white w-2/4 rounded text-primary">
//                 <input
//                   className="bg-transparent px-3 h-8 text-xs font-medium w-full text-primary placeholder-light-grey rounded"
//                   placeholder="Search by job title"
//                 />
//               </div>
//               <div className="bg-white w-1/3 rounded">
//                 <input
//                   className="bg-transparent px-3 h-8 text-xs font-medium w-full text-primary placeholder-light-grey rounded"
//                   placeholder="Sort by"
//                 />
//               </div>
//             </div>
//           </div>

//           <div className="grid grid-cols-[1.5fr,1fr,1fr,1fr,1fr,1fr] gap-2 px-6 py-4 bg-[#FAFAFA] text-xs font-semibold text-[#6F6F6F]  border-gray-200 rounded-lg mt-8">
//             <div>Job title</div>
//             <div className="pl-12">% Matched</div>
//             <div className="text-center">Time Matched</div>
//             <div className="text-center">Status</div>
//             <div className="text-center">Agency</div>
//             <div className="text-center">Reference</div>
//           </div>

//           <div className="overflow-y-scroll no-scrollbar mt-1">
//             <div className="overflow-y-scroll no-scrollbar">
//               {jobList?.length > 0 ? (
//                 jobList.map((data, index) => (
//                   <div
//                     key={index}
//                     className="grid grid-cols-[1.5fr,1fr,1fr,1fr,1fr,1fr]  gap-2 items-center px-6 py-6 text-xs  border-b text-gray-700 radius-[4px] border-gray-200 hover:bg-gray-50 cursor-pointer"
//                     onClick={() => handleItemClick(data)}
//                   >
//                     <div className="font-bold text-gray-800">
//                       {data?.jobTitle ?? "N/A"}
//                     </div>
//                     <div className="font-bold text-center text-gray-800">
//                       {data?.matchingPercentage ?? "N/A"}
//                     </div>
//                     <div className="text-gray-500 italic text-center">
//                       {dayjs(data?.createdAt).format("h:mm a DD MMMM YYYY")}
//                     </div>
//                     <div className="text-gray-600 font-medium pl-16">
//                       {data?.viewedByCandidate === false
//                         ? "Viewd"
//                         : " Not Viewd"}
//                     </div>

//                     <div className="text-[#6F6F6F] text-center">
//                       {data?.companyDetails?.name ?? "N/A"}
//                     </div>
//                     <div className="text-[#6F6F6F] font-normal text-center">
//                       {data?.refNo ?? "N/A"}
//                     </div>
//                   </div>
//                 ))
//               ) : (
//                 <p className="text-sm text-center text-gray-500 mt-20">
//                   No matching jobs found yet.......
//                 </p>
//               )}
//             </div>
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

// export default JobMatchesPage;

import React, { useCallback, useEffect, useRef, useState } from "react";
import LoadingAnimation from "../../assets/svg/LoadingAnimation";
import { colors } from "@nextui-org/theme";
import { useNavigate } from "react-router-dom";
import { candidateMatchedJobs, jobSeen } from "../../endpoints/job.service";
import dayjs from "@lib/dayjs";
import { enqueueSnackbar } from "notistack";

const JobMatchesPage = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [jobList, setJobList] = useState([]);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [hasMore, setHasMore] = useState(true);
  const scrollRef = useRef();

  const fetchMatchedJobs = useCallback(
    async (currentPage = 1) => {
      try {
        setIsLoading(true);
        const { data, success } = await candidateMatchedJobs(
          currentPage,
          limit
        );
        if (success) {
          setJobList((prev) => (currentPage === 1 ? data : [...prev, ...data]));
          setHasMore(data.length === limit);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    },
    [limit]
  );

  useEffect(() => {
    fetchMatchedJobs(1);
  }, [fetchMatchedJobs]);

  useEffect(() => {
    const handleScroll = () => {
      const container = scrollRef.current;
      if (!container || isLoading || !hasMore) return;

      const threshold = 50;
      const isBottom =
        container.scrollHeight - container.scrollTop <=
        container.clientHeight + threshold;

      if (isBottom) {
        const nextPage = page + 1;
        setPage(nextPage);
        fetchMatchedJobs(nextPage);
      }
    };

    const container = scrollRef.current;
    container?.addEventListener("scroll", handleScroll);

    return () => container?.removeEventListener("scroll", handleScroll);
  }, [page, isLoading, hasMore, fetchMatchedJobs]);

  const handleJobSeen = async (jobId) => {
    try {
      setIsLoading(true);
      await jobSeen({ jobId });
    } catch (error) {
      enqueueSnackbar(error + "Error sending message", {
        variant: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleItemClick = (item) => {
    handleJobSeen(item.jobId);
    navigate("/job-matches/job-matches-details", { state: { item } });
  };

  return (
    <div className="flex flex-col rounded-lg bg-white w-full flex-grow p-6 overflow-hidden">
      <div className="flex flex-col gap-4 justify-around rounded-lg bg-[#F1F5F9] py-4 px-6 mb-5">
        <div className="flex items-center w-full gap-6">
          <div className="bg-white w-2/4 rounded text-primary">
            <input
              className="bg-transparent px-3 h-8 text-xs font-medium w-full text-primary placeholder-light-grey rounded"
              placeholder="Search by job title"
            />
          </div>
          <div className="bg-white w-1/3 rounded">
            <input
              className="bg-transparent px-3 h-8 text-xs font-medium w-full text-primary placeholder-light-grey rounded"
              placeholder="Sort by"
            />
          </div>
        </div>
      </div>

      <div className="grid grid-cols-[1.5fr,1fr,1fr,1fr,1fr,1fr] gap-2 px-6 py-4 bg-[#FAFAFA] text-xs font-semibold text-[#6F6F6F] border-gray-200 rounded-lg mt-4">
        <div>Job title</div>
        <div className="pl-12">% Matched</div>
        <div className="text-center">Time Matched</div>
        <div className="text-center">Status</div>
        <div className="text-center">Agency</div>
        <div className="text-center">Reference</div>
      </div>

      <div
        className="overflow-y-scroll no-scrollbar mt-1 flex-1"
        ref={scrollRef}
      >
        {jobList?.length > 0 ? (
          <>
            {jobList.map((data, index) => (
              <div
                key={index}
                className="grid grid-cols-[1.5fr,1fr,1fr,1fr,1fr,1fr] gap-2 items-center px-6 py-6 text-xs border-b text-gray-700 hover:bg-gray-50 cursor-pointer"
                onClick={() => handleItemClick(data)}
              >
                <div className="font-bold text-gray-800">
                  {data?.jobTitle ?? "N/A"}
                </div>
                <div className="font-bold text-center text-gray-800">
                  {data?.matchingPercentage ?? "N/A"}
                </div>
                <div className="text-gray-500 italic text-center">
                  {dayjs(data?.createdAt).format("h:mm a DD MMMM YYYY")}
                </div>
                <div className="text-gray-600 font-medium text-center">
                  {data?.viewedByCandidate === false ? "Not Viewed" : "Viewed"}
                </div>
                <div className="text-[#6F6F6F] text-center">
                  {data?.companyDetails?.name ?? "N/A"}
                </div>
                <div className="text-[#6F6F6F] font-normal text-center">
                  {data?.refNo ?? "N/A"}
                </div>
              </div>
            ))}

            {isLoading && hasMore && (
              <div className="flex justify-center py-4">
                <LoadingAnimation color={colors.black} className="w-5 h-5" />
              </div>
            )}
          </>
        ) : !isLoading ? (
          <p className="text-sm text-center text-gray-500 mt-20">
            No matching jobs found yet.
          </p>
        ) : (
          <div className="flex items-center justify-center h-full py-20">
            <LoadingAnimation color={colors.black} className={"w-6 h-6"} />
          </div>
        )}
      </div>
    </div>
  );
};

export default JobMatchesPage;
